import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, AlertTriangle } from 'lucide-react';
import { Button } from './ui/Button';
import { signOut } from '../lib/auth';
import { useTranslation } from 'react-i18next';

const TrialExpiredScreen: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="bg-white p-8 rounded-xl shadow-sm border border-[#EAECF0]">
          <div className="w-12 h-12 bg-[#FFFAEB] rounded-full flex items-center justify-center mx-auto mb-6">
            <AlertTriangle className="w-6 h-6 text-[#F79009]" />
          </div>

          <h2 className="text-2xl font-semibold text-[#101828] mb-3">
            {t('trialExpiredScreen.title')}
          </h2>
          
          <p className="text-[#667085] mb-4">
            {t('trialExpiredScreen.message')}
          </p>

          <p className="text-[#667085] mb-8">
            {t('trialExpiredScreen.contactLine', { email: 'hello@praxi.hu' })}
          </p>

          <Button
            variant="secondary"
            onClick={handleLogout}
            leftIcon={<LogOut className="w-4 h-4" />}
            className="text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            {t('trialExpiredScreen.logoutButton')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TrialExpiredScreen; 